import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading } from '../../../../components';
import { TeamOutlined, UploadOutlined } from '@ant-design/icons';
import { cityByProvince } from '../../../../redux/actions/master/cities/citiesAction';
import { provinceByCountry } from '../../../../redux/actions/master/provinces/provincesAction';
import { masterCountries, unmountMasterCountries } from '../../../../redux/actions/master/countries/countriesAction';
import { masterJobIndustries, unmountMasterJobIndustries } from '../../../../redux/actions/master/jobIndustries/jobIndustriesAction';
import { Card, Row, Col, PageHeader, Form, Input, Select, Upload, Button, Breadcrumb, message, Typography } from 'antd';
import { masterCategory, unmountMasterCategory } from '../../../../redux/actions/category/categoryAction';
import { createInstructor } from '../../../../redux/actions/instructor/instructorAction';

class CreateInstructor extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props)
    
    this.state = {
      submitLoading: false,
      callingCode: "62",
      dataProvince: [],
      dataCity: [],
      current: false,
      statusSubmit: null
    }
  }

  componentDidMount()  {
    const { 
      actionGetCategory,
      actionGetCountry
    } = this.props;
    actionGetCategory()
    actionGetCountry()
  }

  handleChangeCallingCode = (_, index) => {
    this.setState({ callingCode: index.children.replace(/^[+]+/, '') })
    this.formRef.current.setFieldsValue({
      mobilePhone: null
    });
  }

  handleChangeCountry = (value) => {
    const { actionGetProvince } = this.props;
    this.formRef.current.setFieldsValue({
      provinceId: null,
      cityId: null,
    });
    return actionGetProvince(value, (response) => {
      this.setState({ dataProvince: response.data })
    })
  }

  handleChangeProvince = (value) => {
    const { actionGetCity } = this.props;
    this.formRef.current.setFieldsValue({
      cityId: null
    });
    if(value !== undefined){
      return actionGetCity(value, (response) => {
        this.setState({ dataCity: response.data })
      })
    }else {
      this.setState({ dataCity: [] })
    }
  }

  handleUpload(){
    return {
      withCredentials: true,
      accept:".png,.jpg,.jpeg",
      beforeUpload: file => {
        const validateSize = file.size >= 500000;
        if (validateSize) {
          message.error('Max file size is 500 KB!');
          return false
        }
        var reader = new FileReader();
        reader.readAsDataURL(file);
        return false;
      },
    }
  }

  handleClick = (type) => {
    this.setState({ statusSubmit: type })
  }

  onFinish = (values) => {
    const { actionCreate, history } = this.props;
    values.profilePicFile = values.profilePicFile.file
    values.socialMedia = values.socialMedia ? values.socialMedia : ''
    values.about = values.about ? values.about : ''
    values.countryId = values.countryId ? values.countryId : ''
    values.provinceId = values.provinceId ? values.provinceId : ''
    values.cityId = values.cityId ? values.cityId : ''
    values.address = values.address ? values.address : ''

    this.setState({ submitLoading: true })
    return actionCreate(values, () => {
      this.setState({ submitLoading: false }, () => {
        message.success('Data created successfully')
        history.push('/instructor')
      })
    }, (err) => {
      this.setState({ submitLoading: false }, () => message.error(err))
    })
  }

  render() {
    const { submitLoading, dataProvince, dataCity } = this.state;
    const { getCategory, getCountry } = this.props;

    if(getCategory.loading || getCountry.loading){
      return <Loading />
    }

    const mobileNumber = (
      <Form.Item 
        noStyle
        name="callingCodeId" 
        initialValue={99} 
        rules={[ {required: true, message: 'Please input your calling code'} ]}
      >
        <Select 
          showSearch
          className="prefix-selector"
          optionFilterProp="children"
          onChange={this.handleChangeCallingCode}
        >
          {
            getCountry.data.map(item => (
              <Select.Option key={item.id} value={item.id}>
                {`+${item.callingCode}`}
              </Select.Option>
            ))
          }
        </Select>
      </Form.Item>
    )

    return (
      <React.Fragment>
        <Form layout="vertical" ref={this.formRef} onFinish={this.onFinish} scrollToFirstError={true}>
          <Row style={{ position: 'sticky', zIndex: 1, width: '100%', top: 62, right: 0, marginTop: -20, marginBottom: 8, paddingBottom: 12, paddingTop: 16, backgroundColor: '#f2f2f2' }}>
            {/* Breadcrumb */}
            <Col span={24}>
              <Breadcrumb>
                <Breadcrumb.Item><TeamOutlined /> Instructors</Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link className="link" to="/instructor">Instructors List</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Create</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            {/* Page Header */}
            <Col span={24}>
              <PageHeader 
                title="Create an Instructor" 
                className="site-page-header"
                extra={[
                  <Link to={'/instructor'}>
                    <Button key="1" className="btn-radius">Cancel</Button>
                  </Link>,
                  <Button key="2" style={{ width: 'auto' }} className="btn-save-primary" type="primary" htmlType="submit" loading={submitLoading} onClick={() => this.handleClick('ACTIVE')}>Create</Button>,
                ]}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            {/* Form */}
            <Col span={24}>
              <Card>
                <Row gutter={16}>
                  <Col span={24} style={{ marginBottom: 30 }}>
                    <Typography.Text style={{ fontSize: 18 }}>General Information</Typography.Text>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Instructor Name" 
                      name="name"
                      validateFirst
                      rules={[
                        { required: true, message: 'This is a required field' },
                        { min: 3, message: 'At least 3 characters long' },
                        { max: 50, message: '50 characters only' },
                      ]}
                      >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Instructor Email" 
                      name="email" 
                      initialValue={undefined}
                      rules={[
                        { type: 'email', message: 'Your email address is invalid'},
                        { required: true, message: 'This is a required field' },
                        { min: 5, message: 'At least 5 characters long' },
                        { max: 50, message: '50 characters only' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Industry Specialization" 
                      name="categoryId" 
                      rules={[
                        { required: true, message: 'This is a required field' },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {
                          getCategory.data.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Mobile Number" 
                      name="mobilePhone" 
                      rules={[
                        { required: true, message: 'This is a required field' },
                        { min: 4, message: 'Your mobile number is invalid' },
                        { max: 13, message: 'Your mobile number is invalid' },
                      ]}
                    >
                      <Input addonBefore={mobileNumber} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Job Title" 
                      name="jobTitle" 
                      validateFirst
                      rules={[
                        { required: true, message: 'This is a required field' },
                        { pattern: /^[A-Za-z., ]*$/, message: 'Numbers are not allowed and only certain special characters are allowed' },
                        { min: 3, message: 'At least 3 characters long' },
                        { max: 50, message: '50 characters only' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  
                  <Col span={12}>
                    <Form.Item 
                      label="Company or Institution" 
                      name="company" 
                      validateFirst
                      rules={[
                        { required: true, message: 'This is a required field' },
                        // { pattern: /^[0-9A-Za-z., ]*$/, message: 'Numbers are not allowed and only certain special characters are allowed' },
                        { min: 3, message: 'At least 3 characters long' },
                        { max: 50, message: '50 characters only' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Photo" 
                      name="profilePicFile" 
                      validateFirst
                      rules={[
                        { required: true, message: 'This is a required field' },
                      ]}
                    >
                      <Upload {...this.handleUpload()} listType="picture" maxCount={1}>
                        <Button style={{ width: '100%' }} className="btn-radius" icon={<UploadOutlined />}>Upload a File</Button>
                      </Upload>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item 
                      label="Social Media Link" 
                      name="socialMedia" 
                      validateFirst
                      rules={[
                        { pattern: /^\S*$/, message: 'No spaces allowed' },
                        { pattern:  /https?:\/\/|www./, message: 'Invalid url' },
                        { max: 100, message: '100 characters only' },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item 
                      label="About" 
                      name="about" 
                    >
                      <Input.TextArea maxLength={500} />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item label="Country" name="countryId">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select a country"
                        optionFilterProp="children"
                        onChange={this.handleChangeCountry}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {
                          getCountry.data.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item label="Province" name="provinceId">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select a province"
                        onChange={this.handleChangeProvince}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {
                          dataProvince.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item label="City" name="cityId">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select a city"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {
                          dataCity.map(item => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item 
                      label="Street Address" 
                      name="address"
                      rules={[
                        { max: 100, message: 'Address is too long. Maximum is 100 characters' },
                      ]}
                    >
                      <Input.TextArea />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    )
  }
  componentWillUnmount() {
    const { unmountGetCategory } = this.props;
    unmountGetCategory()
  }
}

const mapStateToProps = (state) => ({
  getJobIndustries  : state.jobIndustries.master,
  getCountry        : state.countries.master,
  getCategory       : state.category.master,
})

const mapDispatchToProps = {
  actionCreate            : createInstructor,
  actionGetJobIndustries  : masterJobIndustries,
  actionGetCategory       : masterCategory,
  actionGetCountry        : masterCountries,
  actionGetProvince       : provinceByCountry,
  actionGetCity           : cityByProvince,
  unmountGetCountry       : unmountMasterCountries,
  unmountGetCategory      : unmountMasterCategory,
  unmountGetJobIndustries : unmountMasterJobIndustries
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateInstructor)
